// src/app/services/message.service.ts
import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, addDoc } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { query, orderBy } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private firestore: Firestore) {}

  storeMessage( name: string, email: string, subject: string, message: string): Observable<any> {
    const mailRef = collection(this.firestore, `mail`);
    return from(addDoc(mailRef, {
      name,
      email,
      subject,
      message,
      timestamp: new Date()
    }));
  }

  getMessages(): Observable<any[]> {
    const mailRef = collection(this.firestore, `mail`);
    const messagesQuery = query(mailRef, orderBy('timestamp', 'desc')); // Order by timestamp descending
    return collectionData(messagesQuery, { idField: 'id' }) as Observable<any[]>;
  }
}